import { render } from "./BatterVisitView.vue?vue&type=template&id=9a72f972&scoped=true"
import script from "./BatterVisitView.vue?vue&type=script&lang=js"
export * from "./BatterVisitView.vue?vue&type=script&lang=js"

import "./BatterVisitView.vue?vue&type=style&index=0&id=9a72f972&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a72f972"]])

export default __exports__